<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-scroll-top-button></app-scroll-top-button>
<app-privacy-policy-management></app-privacy-policy-management>
